/* PRACTICTECH — couche d'animation et d'achat (brouillon)
 * - Aucune dépendance. Chargé en "defer".
 * - Animations uniquement via transform / opacity / variables CSS.
 * - Si ce fichier ne se charge pas, ou si l'utilisateur préfère moins d'animations,
 *   tout le contenu reste visible et l'achat fonctionne (formulaire Shopify natif).
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canIO = 'IntersectionObserver' in window;

  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[pt]', e); } }

  /* ---------- 1. Révélations au scroll ---------- */
  var pendingReveal = [];
  function sweepReveal() {
    if (!pendingReveal.length) return;
    var lim = window.innerHeight * 0.92;
    pendingReveal = pendingReveal.filter(function (el) {
      if (el.classList.contains('is-in')) return false;
      if (el.getBoundingClientRect().top < lim) { el.classList.add('is-in'); return false; }
      return true;
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('[data-pt-reveal]');
    if (!els.length) return;
    if (reduce || !canIO) { return; }
    root.classList.add('pt-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // visible, ou déjà dépassé (défilement rapide / ancre) : on révèle
        if (en.isIntersecting || en.boundingClientRect.top < 0) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: [0, 0.12] });
    els.forEach(function (el) {
      // Ce qui est déjà à l'écran au chargement apparaît sans attendre
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) { requestAnimationFrame(function () { el.classList.add('is-in'); }); }
      else { io.observe(el); pendingReveal.push(el); }
    });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    // Filet de sécurité : rien ne doit rester invisible
    window.addEventListener('pagehide', function () { els.forEach(function (el) { el.classList.add('is-in'); }); });
  }

  /* ---------- 2. Progression au scroll (--p de 0 à 1) ---------- */
  var tracked = [];
  var active = new Set();
  var ticking = false;

  function measure(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    var mode = el.getAttribute('data-pt-scroll');
    var p;
    if (mode === 'pin') {
      // Traversée d'une zone plus haute que l'écran (scène sticky)
      var total = r.height - vh;
      p = total > 0 ? -r.top / total : 0;
    } else if (mode === 'leave') {
      // 0 quand le haut de l'élément est en haut de l'écran, 1 quand il est sorti
      p = -r.top / Math.max(r.height, 1);
    } else {
      // 0 quand l'élément entre par le bas, 1 quand il sort par le haut
      p = (vh - r.top) / (vh + r.height);
    }
    p = Math.min(1, Math.max(0, p));
    el.style.setProperty('--p', p.toFixed(4));
    if (el._ptOnProgress) el._ptOnProgress(p);
  }

  function frame() {
    ticking = false;
    active.forEach(measure);
    sweepReveal();
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }

  function initScroll() {
    tracked = Array.prototype.slice.call(document.querySelectorAll('[data-pt-scroll]'));
    if (!tracked.length || !canIO) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { active.add(en.target); measure(en.target); }
        else { measure(en.target); active.delete(en.target); }
      });
    }, { rootMargin: '10% 0px 10% 0px' });
    tracked.forEach(function (el) {
      if (reduce && !el.hasAttribute('data-pt-keep')) return;
      io.observe(el);
    });
    // capture : Horizon fait défiler .page-wrapper (et non la fenêtre) sur ordinateur
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---------- 3. Scène « anatomie » : étapes pilotées par le scroll ---------- */
  function initAnatomy() {
    document.querySelectorAll('[data-pt-anatomy]').forEach(function (sec) {
      if (reduce || !canIO) return; // version liste statique
      var track = sec.querySelector('.pt-anatomy__track');
      var steps = sec.querySelectorAll('.pt-anatomy__step');
      var frames = sec.querySelectorAll('.pt-anatomy__frame');
      var dots = sec.querySelectorAll('.pt-anatomy__dots i');
      var n = steps.length;
      if (!track || n < 2) return;
      sec.classList.add('is-live');
      var current = -1;
      function set(i) {
        if (i === current) return;
        current = i;
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        var f = steps[i] ? steps[i].getAttribute('data-frame') : '0';
        frames.forEach(function (fr) { fr.classList.toggle('is-active', fr.getAttribute('data-frame') === f); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.classList.toggle('is-done', k < i); });
      }
      track._ptOnProgress = function (p) { set(Math.min(n - 1, Math.floor(p * n * 0.999))); };
      set(0);
    });
  }

  /* ---------- 4. Achat : couleur, prix, ajout au panier ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (fmt || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, withDot)
      .replace(/<[^>]*>/g, '');
  }

  function toast(msg) {
    var t = document.querySelector('.pt-toast');
    if (!t) { t = document.createElement('div'); t.className = 'pt-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  function addToCart(variantId, btn, form) {
    var actions = window.Shopify && window.Shopify.actions;
    // Filet de sécurité : sans l'API standard du thème, on soumet le formulaire Shopify natif.
    if (!actions || typeof actions.updateCart !== 'function') { form.submit(); return; }
    btn.setAttribute('aria-busy', 'true');
    var msg = form.querySelector('.pt-buy__msg');
    if (msg) { msg.textContent = ''; msg.removeAttribute('data-type'); }
    actions.updateCart(
      { lines: [{ merchandiseId: String(variantId), quantity: 1 }] },
      { event: { context: 'product' } }
    ).then(function (res) {
      btn.removeAttribute('aria-busy');
      if (res && res.userErrors && res.userErrors.length) { throw new Error(res.userErrors[0].message); }
      btn.setAttribute('data-state', 'added');
      var label = btn.querySelector('.pt-btn__label');
      var old = label ? label.textContent : '';
      if (label) label.textContent = 'Ajouté au panier ✓';
      toast('Ajouté au panier');
      setTimeout(function () { btn.removeAttribute('data-state'); if (label) label.textContent = old; }, 2200);
      if (actions.openCart) { actions.openCart(); }
    }).catch(function (err) {
      btn.removeAttribute('aria-busy');
      if (msg) { msg.textContent = (err && err.message) || 'Impossible d’ajouter au panier. Réessaie.'; msg.setAttribute('data-type', 'error'); }
    });
  }

  function initBuy() {
    document.querySelectorAll('[data-pt-buy]').forEach(function (box) {
      var form = box.querySelector('form');
      var dataEl = box.querySelector('script[data-pt-variants]');
      if (!form || !dataEl) return;
      var variants = JSON.parse(dataEl.textContent || '[]');
      var fmt = box.getAttribute('data-money-format');
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = box.querySelector('[data-pt-price]');
      var colorEl = box.querySelector('[data-pt-color]');
      var btn = form.querySelector('[data-pt-add]');

      function current() {
        var id = idInput ? idInput.value : null;
        for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
        return variants[0];
      }
      function sync(v) {
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, fmt);
        if (colorEl && colorEl.textContent !== v.label) { colorEl.textContent = v.label; colorEl.classList.remove('is-swap'); void colorEl.offsetWidth; colorEl.classList.add('is-swap'); }
        if (btn) {
          btn.disabled = !v.available;
          var l = btn.querySelector('.pt-btn__label');
          if (l) l.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
        }
        document.querySelectorAll('[data-pt-sticky-color]').forEach(function (s) { s.textContent = v.label + ' · ' + money(v.price, fmt); });
        document.dispatchEvent(new CustomEvent('pt:variant', { detail: v }));
      }
      box.querySelectorAll('.pt-swatch input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === inp.value) sync(variants[i]);
        });
      });
      form.addEventListener('submit', function (e) {
        var v = current();
        if (!v || !v.available) { e.preventDefault(); return; }
        if (window.Shopify && window.Shopify.actions) { e.preventDefault(); addToCart(v.id, btn, form); }
      });
      // Barre fixe : ajoute la couleur actuellement choisie
      document.querySelectorAll('[data-pt-sticky-add]').forEach(function (sb) {
        sb.addEventListener('click', function (e) {
          var v = current();
          if (!v || !v.available) return;
          e.preventDefault();
          if (window.Shopify && window.Shopify.actions) addToCart(v.id, sb, form);
          else form.submit();
        });
      });
      sync(current());
    });
  }

  /* ---------- 5. Barre d'achat fixe ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-pt-sticky]');
    if (!bar || !canIO) return;
    var hero = document.querySelector('[data-pt-hero]');
    var btn = document.querySelector('[data-pt-buy] [data-pt-add]');
    var footer = document.querySelector('[data-pt-footer]') || document.querySelector('footer');
    var state = { heroOut: !hero, btnVis: false, btnAbove: false, footIn: false };
    function apply() {
      var on = !state.btnVis && !state.footIn && (hero ? (state.heroOut || state.btnAbove) : true);
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelectorAll('a,button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }
    function watch(el, fn) {
      if (!el) return;
      new IntersectionObserver(function (en) { fn(en[0]); apply(); }, { threshold: 0 }).observe(el);
    }
    watch(hero, function (e) { state.heroOut = !e.isIntersecting && e.boundingClientRect.top < 0; });
    watch(btn, function (e) { state.btnVis = e.isIntersecting; state.btnAbove = !e.isIntersecting && e.boundingClientRect.top < 0; });
    watch(footer, function (e) { state.footIn = e.isIntersecting; });
    apply();
  }

  /* ---------- 6. Ancres douces ---------- */
  function initAnchors() {
    document.querySelectorAll('a[data-pt-anchor]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').split('#')[1];
        var t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
  }

  /* ---------- 7. Libellés FR des couleurs (affichage uniquement) ---------- */
  var LBL = { black: 'Noir', pink: 'Rose', blue: 'Bleu', orange: 'Orange', color: 'Couleur' };
  function relabel() {
    document.querySelectorAll('.cart-items__title').forEach(function (el) { var t = el.textContent; if (t.indexOf(' — ') > 0) el.textContent = t.split(' — ')[0].trim(); });
    document.querySelectorAll('.sticky-add-to-cart__variant, .cart-items__variant dd, .cart-items__variants dd').forEach(function (el) {
      var t = el.textContent.trim().replace(/,$/, '').trim();
      var k = t.toLowerCase();
      if (LBL[k]) el.textContent = el.textContent.replace(t, LBL[k]);
    });
  }
  function initRelabel() {
    relabel();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; relabel(); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- 8. Galerie produit (swipe natif + vignettes + flèches) ---------- */
  function initGallery() {
    document.querySelectorAll('[data-pt-gal]').forEach(function (g) {
      if (g._pt) return; g._pt = true;
      var track = g.querySelector('[data-pt-gal-track]');
      if (!track) return;
      var slides = track.children;
      var thumbs = g.querySelectorAll('[data-pt-gal-go]');
      var cur = g.querySelector('[data-pt-gal-cur]');
      var idx = 0;
      function go(i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: (smooth === false || reduce) ? 'auto' : 'smooth' });
      }
      function mark(i) {
        if (i === idx) return; idx = i;
        if (cur) cur.textContent = i + 1;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      track.addEventListener('scroll', function () { mark(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-pt-gal-go')); }); });
      var prev = g.querySelector('[data-pt-gal-prev]'), next = g.querySelector('[data-pt-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      });
    });
  }

  /* ---------- 9. Rail horizontal : barre de progression ---------- */
  function initRails() {
    document.querySelectorAll('[data-pt-rail]').forEach(function (r) {
      var sec = r.closest('section');
      if (!sec) return;
      var raf = 0;
      function upd() { raf = 0; var max = r.scrollWidth - r.clientWidth; sec.style.setProperty('--rail', max > 0 ? (r.scrollLeft / max).toFixed(3) : 0); }
      r.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  /* ---------- 10. En-tête : état « défilé » + hauteur ---------- */
  function initHeader() {
    var h = document.querySelector('header-component, .header-section, #header-component');
    function setH() { var v = h ? Math.round(h.getBoundingClientRect().height) : 0; if (v > 0) root.style.setProperty('--pt-header-h', v + 'px'); }
    setH(); window.addEventListener('resize', setH, { passive: true });
    var last = -1;
    function st() {
      var y = window.scrollY || 0;
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollTop) y = pw.scrollTop;
      var on = y > 12;
      if (on !== last) { last = on; root.classList.toggle('pt-scrolled', on); }
    }
    document.addEventListener('scroll', function () { requestAnimationFrame(st); }, { passive: true, capture: true });
    st();
    // point « capteur » après le nom de la marque (texte du logo uniquement)
    document.querySelectorAll('.header-logo__text, .header-logo span, .header__heading-link span').forEach(function (el) {
      if (!el.querySelector('img') && /practic/i.test(el.textContent)) el.classList.add('pt-logo-dot');
    });
  }

  /* ---------- 11. Boutons : reflet qui suit le doigt / la souris ---------- */
  function initButtons() {
    if (reduce) return;
    document.addEventListener('pointermove', function (e) {
      var b = e.target.closest && e.target.closest('.pt-btn');
      if (!b) return;
      var r = b.getBoundingClientRect();
      b.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      b.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  function boot() {
    safe(initReveal);
    safe(initAnatomy);
    safe(initScroll);
    safe(initBuy);
    safe(initSticky);
    safe(initAnchors);
    safe(initRelabel);
    safe(initGallery);
    safe(initRails);
    safe(initHeader);
    safe(initButtons);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Éditeur de thème : réinitialise quand une section est rechargée
  document.addEventListener('shopify:section:load', function () { safe(initReveal); safe(initAnatomy); safe(initScroll); safe(initBuy); safe(initSticky); safe(initGallery); safe(initRails); });
})();
